export function TolstoyHeadScripts() {
	return (
		<>
			<script
				dangerouslySetInnerHTML={{
					__html: `tolstoyAppKey="bb9fda97-8d57-4f96-a80a-11020a047ab4";`,
				}}
			/>
			<script
				type='module'
				async
				src='https://widget.gotolstoy.com/we/widget.js'
			>
			</script>
			<script
				type='text/javascript'
				nomodule
				async
				src='https://widget.gotolstoy.com/widget/widget.js'
			>
			</script>
			<script
				type='module'
				src='https://play.gotolstoy.com/widget-v2/widget.js'
			>
			</script>
		</>
	)
}
